import React from "react"
import { useParams } from "react-router-dom"
import { Tooltip } from "antd"
import { Link } from "react-router-dom"
import "./ActivityCellWithFlag.scss"

// types
import type { Assessment, ActivityType } from "../../../assessment-types"

type ActivityCellWithFlagProps = {
  activityId?: number
  activityTitle?: string
  data: Assessment
  activityTypes: ActivityType[]
}

const ActivityCellWithFlag = ({ activityId, activityTitle, data, activityTypes }: ActivityCellWithFlagProps) => {
  const { studyId } = useParams()

  const renderRecommTypeFlag = () => {
    // get all recommended field IDs (project_type_ids) that are not in attached_projects
    const getFilteredTypeIds = () => {
      let fields: number[] = []
      if (data?.project_type_ids?.length > 0) {
        // get IDs for attached_projects from activityTypes
        const attachedIds = data.attached_projects.map(
          (attachObj) => activityTypes.find((typeObj) => typeObj.title === attachObj.project_type_title)?.id
        )

        // if the operator is "or", and one of the recommended activities has been attached, the requirements have been satisfied, therefore do not return any IDs
        if (
          data.operator === "|" &&
          data?.attached_projects?.length &&
          attachedIds.some((attachId) => data.project_type_ids.some((recId) => attachId === recId))
        ) {
          fields = []
        }
        // do not include activities already attached
        else {
          fields = data.project_type_ids.filter((typeId) => !attachedIds.some((attachId) => attachId === typeId))
        }
      }
      return fields
    }
    if (activityTypes && getFilteredTypeIds()?.length) {
      return (
        <Tooltip
          title={
            <div className="activities-flag-tooltip-content">
              Recommended activities:
              <br />
              {getFilteredTypeIds()
                .map((id) => activityTypes?.find((typeObj) => typeObj.id === id)?.title)
                .join(data.operator === "|" ? " or " : " and ")}
            </div>
          }
          rootClassName="activities-flag-tooltip"
        >
          <i className="fas fa-flag" />
        </Tooltip>
      )
    }
    return null
  }

  return (
    <div className={`activity-cell-renderer`}>
      <div className="activity-container">
        <div className="activities-flag-wrap">
          {activityTitle && activityId && (
            <Link
              className="activity-link"
              to={`/study/${studyId}/activity/${activityId}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {activityTitle}
            </Link>
          )}
          {/* not showing fields for some results and when there are missing fields */}
          {data.result !== "Not Required" &&
            data.result !== "Not Yet Assessed" &&
            (!data.missing_fields || data?.missing_fields.length === 0) &&
            renderRecommTypeFlag()}
        </div>
      </div>
    </div>
  )
}

export default ActivityCellWithFlag
